import React from 'react'
import { connect } from 'react-redux'
import styles from './Body.module.css';
import { getDateMDYY } from '_helpers'
import { PatientDot } from '_components';
import {
    PatientHomeAdmissionAuths,
    PatientHomeAdmissionPocs,
    PatientHomeAdmissionFoto,
    PatientHomeAdmissionRTM,
    PatientHomeAdmissionContraindications,
    PatientHomeAdmissionDiagnosis
} from 'PatientCareCenter/Home/Admissions'

class PatientHomeAdmissionBody extends React.Component {

    render() {
        if (this.props.visible) {
            return (
                <div>
                    <div className={styles.body_wrapper}>
                        <div className={styles.body_left}>
                            <div className={styles.demog_table}>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}>Start Date:</span>
                                    <span className={styles.demog_row_data}>{getDateMDYY(this.props.admission.startDate)}</span>
                                </div>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}>Onset Date:</span>
                                    <span className={styles.demog_row_data}>{getDateMDYY(this.props.admission.onsetDate)}</span>
                                </div>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}>DOT:</span>
                                    <span className={styles.demog_row_data}>
                                        <PatientDot id={this.props.admission.dot} className={styles.patient_dot} />{this.props.colorName}
                                    </span>
                                </div>


                                {Object.keys(this.props.insured)
                                    .map(id => {
                                        const i = this.props.insured[id];
                                        return (
                                            <div key={i.id} className={styles.demog_row}>
                                                <span className={styles.demog_row_header}>{i.position === 1 ? 'Payers:' : ''}</span>
                                                <span className={styles.demog_row_data} title={i.payerName + ' - ' + i.contractName}>
                                                    {i.position + ' - ' + i.payerName}
                                                </span>
                                            </div>
                                        )
                                    })
                                }

                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}>Physician:</span>
                                    <span className={styles.demog_row_data}>{this.props.admission.physicianName}</span>
                                </div>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}></span>
                                    <span className={styles.demog_row_data}>{this.props.admission.physicianPhone}</span>
                                </div>
                                <div className={styles.demog_row}>
                                    <span className={styles.demog_row_header}></span>
                                    <span className={styles.demog_row_data}>{this.props.admission.physicianEmail}</span>
                                </div>


                            </div>

                            {Object.keys(this.props.caseMgrs)
                                .map(id => {
                                    const cm = this.props.caseMgrs[id];
                                    return (
                                        <div className={styles.demog_table} key={cm.id}>
                                            <div key={cm.id + '_name'} className={styles.demog_row}>
                                                <span className={styles.demog_row_header}>Case Manager:</span>
                                                <span className={styles.demog_row_data} title={cm.name}>{cm.name}</span>
                                            </div>
                                            <div key={cm.id + '_phone'} className={styles.demog_row}>
                                                <span className={styles.demog_row_data}></span>
                                                <span className={styles.demog_row_data} title={cm.phone}>{cm.phone}</span>
                                            </div>
                                            <div key={cm.id + '_email'} className={styles.demog_row}>
                                                <span className={styles.demog_row_data}></span>
                                                <span className={styles.demog_row_data} title={cm.email}>{cm.email}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }

                            {Object.keys(this.props.insured)
                                .map(id => {
                                    const i = this.props.insured[id];
                                    return (
                                        <PatientHomeAdmissionAuths key={i.id} epno={i.epno} pyno={i.pyno} />
                                    )
                                })
                            }

                            <PatientHomeAdmissionPocs epno={this.props.admission.id} />

                            <PatientHomeAdmissionFoto epno={this.props.admission.id} />

                        </div>
                        <div className={styles.body_right}>
                            <PatientHomeAdmissionContraindications epno={this.props.admission.id} />
                            <PatientHomeAdmissionDiagnosis epno={this.props.admission.id} />
                        </div>
                    </div >
                    {this.props.rtmEnabled &&
                        <PatientHomeAdmissionRTM epno={this.props.admission.id} />
                    }
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    }
}

function mapStateToProps(state, ownprops) {
    return {
        admission: state.entities.admissions[ownprops.id],
        colorName: state.entities.admissions[ownprops.id].dot ? state.entities.masterData.DOTCOLORS[state.entities.admissions[ownprops.id].dot].COLORNAME : undefined,
        visible: state.ui.admissions[ownprops.id].visible,
        insured: Object.keys(state.entities.insured)
            .filter(key => { return state.entities.insured[key].epno === ownprops.id })
            .sort((a, b) => state.entities.insured[a].position - state.entities.insured[b].position)
            .map(key => state.entities.insured[key]),
        caseMgrs: Object.keys(state.entities.caseMgrs)
            .filter(key => { return state.entities.caseMgrs[key].epno === ownprops.id })
            .sort((a, b) => state.entities.caseMgrs[a].position - state.entities.caseMgrs[b].position)
            .map(key => state.entities.caseMgrs[key]),
        //        rtmEnabled: state.entities.masterData.PROPS['RTM_ENABLED'] && state.entities.masterData.PROPS['RTM_ENABLED'].PRVALUE === 'true' ? true : false
        rtmEnabled: false

    };
}

const connectedPatientHomeAdmissionBody = connect(mapStateToProps)(PatientHomeAdmissionBody);
export { connectedPatientHomeAdmissionBody as PatientHomeAdmissionBody };

